// generated by the plop

import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { PROGRESS_STATUSES } from 'symbols';
import { ClientService } from '../../services/client.service';
import { GetClientInfo, GetClientInfoByToken, GetClients, GetStoryByClientId } from './client.actions';
import { CLIENT_STATE_DEFAULT, ClientStateModel } from './client.model';

@State({ name: 'Client', defaults: CLIENT_STATE_DEFAULT })
@Injectable()
export class ClientState {

  constructor(private clientService: ClientService) {
  }

  @Selector()
  static loadClientListStatus(state: ClientStateModel): ClientStateModel['loadClientListStatus'] {
    return state.loadClientListStatus;
  }

  @Selector()
  static clientList(state: ClientStateModel): ClientStateModel['clientList'] {
    return state.clientList;
  }

  @Selector()
  static currentClientStory(state: ClientStateModel): ClientStateModel['currentClientStory'] {
    return {
      ...state.currentClientStory,
      callLogs: state.currentClientStory?.callLogs?.reverse()
    };
  }

  @Selector()
  static loadStoryStatus(state: ClientStateModel): ClientStateModel['loadStoryStatus'] {
    return state.loadStoryStatus;
  }


  @Selector()
  static currentClientInfo(state: ClientStateModel): ClientStateModel['currentClientInfo'] {
    return state.currentClientInfo;
  }


  @Action(GetClients)
  getClientList(ctx: StateContext<ClientStateModel>, { phone }: GetClients): void {
    ctx.patchState({
      loadClientListStatus: PROGRESS_STATUSES.IN_PROGRESS
    });

    this.clientService.getClientListForSelectors(phone)
      .subscribe({
        next: (clientList) => {
          ctx.patchState({
            clientList,
            loadClientListStatus: PROGRESS_STATUSES.SUCCESS
          });
        },
        error: () => {
          ctx.patchState({
            loadClientListStatus: PROGRESS_STATUSES.FAIL
          });
        }
      });
  }

  @Action(GetStoryByClientId)
  getStoryByClientId(ctx: StateContext<ClientStateModel>, { id }: GetStoryByClientId): void {
    ctx.patchState({
      loadStoryStatus: PROGRESS_STATUSES.IN_PROGRESS
    });

    this.clientService.getStory(id)
      .subscribe({
        next: (currentClientStory) => {
          ctx.patchState({
            currentClientStory,
            loadStoryStatus: PROGRESS_STATUSES.SUCCESS
          });
        },
        error: () => {
          ctx.patchState({
            loadStoryStatus: PROGRESS_STATUSES.FAIL
          });
        }
      });
  }

  @Action(GetClientInfo)
  getClientInfo(ctx: StateContext<ClientStateModel>, { id }: GetStoryByClientId): void {
    ctx.patchState({
      loadStoryStatus: PROGRESS_STATUSES.IN_PROGRESS
    });

    this.clientService.getClientInfo(id)
      .subscribe({
        next: (currentClientInfo) => {
          ctx.patchState({
            currentClientInfo,
            loadStoryStatus: PROGRESS_STATUSES.SUCCESS
          });
        },
        error: () => {
          ctx.patchState({
            loadStoryStatus: PROGRESS_STATUSES.FAIL
          });
        }
      });
  }

  @Action(GetClientInfoByToken)
  getClientInfoByToken(ctx: StateContext<ClientStateModel>): void {
    ctx.patchState({
      loadStoryStatus: PROGRESS_STATUSES.IN_PROGRESS
    });

    this.clientService.getClientInfoByToken()
      .subscribe({
        next: (currentClientStory) => {
          ctx.patchState({
            currentClientStory,
            loadStoryStatus: PROGRESS_STATUSES.SUCCESS
          });
        },
        error: () => {
          ctx.patchState({
            loadStoryStatus: PROGRESS_STATUSES.FAIL
          });
        }
      });
  }
}


